import {computed, observable} from "mobx";

import {BaseWidgetDisplayModel} from "../../models/base-widget-display-model";
import {LIVE_STREAMING_MODULE} from "../../../widgets/match-widget/modules/live-streaming-module/live-streaming-widget.consts";

export class AppLiveStreamingDisplayModel extends BaseWidgetDisplayModel {
  @observable stripColorMode: String;

  constructor() {
    super();

    this.stripColorMode = LIVE_STREAMING_MODULE.STRIP_COLOR_MODE.light;
  }

  @computed get isLightMode(): Boolean {
    const isLightMode: Boolean = this.stripColorMode === LIVE_STREAMING_MODULE.STRIP_COLOR_MODE.light

    return isLightMode
  }
}
